import axios from 'axios'

export function getSubscriptions(agrmId) {
  return axios.get('subscriptions', {
    params: {
      agrmid: agrmId,
      filterActive: true
    }
  }).then(response => {
    return response.data.results
  }).catch(error => {
    console.log(error)
    return null
  })
}
